import {FC, SVGProps} from 'react';

export const ArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M16 6L6 16L16 26" stroke="currentColor" strokeWidth="2" />
		<line x1="6" y1="16" x2="28" y2="16" stroke="currentColor" strokeWidth="2" />
	</svg>
);
